export default "__VITE_ASSET__9536a250__"